export function insertIf<T>(
  condition: boolean | undefined,
  ...elements: T[]
): T[] {
  return condition ? elements : [];
}
